import Spinner from "./spinner";

export { Spinner };
